import { request } from '@/utils/request'
/**
 *
 * @param {obj} data
 * @returns
 */
export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data: {
      data: data
    }
  })
}
export function logout(data) {
  return request({
    url: '/user/logout',
    method: 'post',
    data: {
      data: {
        token: data
      }
    }
  })
}

// 修改密码
export function savepassword(user) {
  return request({
    url: '/common/savepassword',
    method: 'post',
    data: {
      data: {
        user
      }
    }
  })
}
// 获取验证码
export function getCode(data) {
  return request({
    url: '/common/sendsms',
    method: 'post',
    data: {
      data: {
        phone: data
      }
    }
  })
}

/**
 * 获取用户菜单
 * @param {string} username
 * @returns {tree}
 */
export function getUserMenu(mobile) {
  return request({
    url: '/menu/getUserMenu',
    method: 'post',
    data: {
      data: {
        mobile
      }
    }
  })
}

//上传base64
// 上传文件
export function imgBase(data) {
  return request({
    url: `/common/imgBase`,
    method: 'post',
    data: {
      data
    }
  })
}



// 上传文件
export function uploadImg(data) {
  return request({
    url: `/upload/img`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}
request.adornUrl = (actionName) => {
  return (process.env.NODE_ENV !== 'production' ? '/company' : '') + actionName
}
// 注册
export function logon(data) {
  return request({
    url: `/common/reg`,
    method: 'post',
    data: {
      data
    }
  })
}
/**
 * 企业详情
 */
export function getEnterpriseDetails(id) {
  return request({
    url: `place/getplaceitem`,
    method: 'post',
    data: {
      data: { id }
    }
  })
}
/**
 * 修改企业详情
 */
export function setEnterpriseDetails(data) {
  return request({
    url: `place/savePlaceInfo`,
    method: 'post',
    data: {
      data
    }
  })
}
/**
 * 修改打卡范围
 */
export function setEnterpriseRange(data) {
  return request({
    url: `place/savePlaceClock`,
    method: 'post',
    data: {
      data
    }
  })
}
/**
 * 修改一标三实信息 [单]
 */
export function saveInfoHouse(house_info) {
  return request({
    url: `/place/saveInfoHouse`,
    method: 'post',
    data: {
      data: {
        house_info
      }
    }
  })
}
/**
 * 修改企业详情信息 [单]
 */
export function saveInfoPlace(place_info) {
  return request({
    url: `/place/saveInfoPlace`,
    method: 'post',
    data: {
      data: {
        place_info
      }
    }
  })
}
/**
 * 从业人员信息
 * 获取列表
 */
export function getEmployees(data) {
  return request({
    url: `employee/getEmployeeList`,
    method: 'post',
    data: {
      data
    }
  })
}
/**
 * 获取人员信息详情
 */
export function getEmployees_details(id) {
  return request({
    url: `employee/seeEmp`,
    method: 'post',
    data: {
      data: { id }
    }
  })
}

/**
 * 新增人员信息
 */
export function addEmployees(data) {
  return request({
    url: `employee/addsaveEmp`,
    method: 'post',
    data: {
      data
    }
  })
}
/**
 * 修改人员信息
 */
export function saveEmployeeItem(data) {
  return request({
    url: `/employee/saveEmployeeItem`,
    method: 'post',
    data: {
      data
    }
  })
}

/**
 * 从业人员-删除
 */
export function delEmp(id) {
  return request({
    url: `/employee/delEmp`,
    method: 'post',
    data: {
      data: { id }
    }
  })
}

/**
 * 重点人员-列表
 */
export function getPointperson(data) {
    return request({
        url: `pointperson/list`,
        method: 'post',
        data: {
            data
        }
    })
}
/**
 * 重点人员-详情
 */
export function getPointperson_details(id) {
    return request({
        url: `pointperson/get`,
        method: 'post',
        data: {
            data: { id }
        }
    })
}

/**
 * 重点人员-新增
 */
export function addPointperson(data) {
    return request({
        url: `pointperson/save`,
        method: 'post',
        data: {
            data
        }
    })
}

// 通知公告
export function getNoticeList(data) {
	return request({
		url: '/notice/getNoticeList',
		method: 'post',
		data: {
			data
		}
	})
}
// 通知公告详情
export function getNoticeItem(id) {
	return request({
		url: '/notice/getNoticeItem',
		method: 'post',
		data: {
			data: { id }
		}
	})
}
// 通知公告-回执
export function receiptNotice(data) {
	return request({
		url: '/notice/addReceipt',
		method: 'post',
		data: {
			data
		}
	})
}

// 获取紧急程度字典
export function getLevel() {
  return request({
	url: '/common/dict',
	method: 'post',
	data: {
      data: {
        typename: 'notice_level'
      }
    }
  })
}

export function dictList(data) {
  return request({
    url: '/common/dictList',
    method: 'post',
    data
  })
}


// 一标三实 行政区划字典
export function getXzqh() {
  return request({
    url: '/common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'XAXZQH'
      }
    }
  })
}
// 一标三实 街路巷字典
export function getJlx(data) {
  return request({
    url: '/common/jlx',
    method: 'post',
    data: {
      data
    }
  })
}
// 一标三实 详细地址字典
export function getArea(data) {
  return request({
    url: '/common/pgisxz',
    method: 'post',
    data: {
      data
    }
  })
}
// 获取营业状态字典
export function getJyzt() {
  return request({
    url: '/common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'jyzt'
      }
    }
  })
}
// 获取行业类别字典
export function getHylb() {
  return request({
    url: '/common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'hylb'
      }
    }
  })
}
// 获取消防等级字典
export function getXfdj() {
  return request({
    url: '/common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'xfdj'
      }
    }
  })
}
// 获取单位性质字典
export function getdwxz() {
  return request({
    url: '/common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'dwxz'
      }
    }
  })
}
// 获取单位类别字典
export function getdwlb() {
  return request({
    url: '/common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'dwlb'
      }
    }
  })
}
// 获取执照类型字典
export function getZzlx() {
  return request({
    url: '/common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'zzlxdm'
      }
    }
  })
}
// 获取九小场所字典
export function getjxcs() {
  return request({
    url: '/common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'jxcs'
      }
    }
  })
}
// 获取娱乐场所类别字典
export function getylcslb() {
  return request({
    url: '/common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'YLCSLXDM'
      }
    }
  })
}
// 获取一标三实 - 房屋类别字典
export function getFwlb() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'fwlb'
      }
    }
  })
}
// 获取一标三实 - 房屋性质字典
export function getFwxz() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'FWXZH'
      }
    }
  })
}
// 获取一标三实 - 房屋用途字典
export function getFwyt() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'fwyt'
      }
    }
  })
}
// 获取一标三实 - 房屋现状字典
export function getFwzt() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'fwxz'
      }
    }
  })
}
// 获取一标三实 - 房屋结构字典
export function getFwjg() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'fwjg'
      }
    }
  })
}
// 获取一标三实 - 证件类型字典
export function getZjlx() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'zjlx'
      }
    }
  })
}
// 获取一标三实 - 证件类型字典
export function getfzgx() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'ybrgx'
      }
    }
  })
}

/**
 * 人员状态字典
 */

export function getryzt() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'RYZT'
      }
    }
  })
}
/**
 * 人员类别字典
 */

export function getrylb() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'rylb'
      }
    }
  })
}
/**
 * 人员性别字典
 */

export function getryxb() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'XB'
      }
    }
  })
}
/**
 * 血型字典
 */

export function getXx() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'XX'
      }
    }
  })
}
/**
 * 国籍字典
 */

export function getGj() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'COUNTRY'
      }
    }
  })
}
/**
 * 民族字典
 */

export function getMz() {
  return request({
    url: 'common/dict',
    method: 'post',
    data: {
      data: {
        typename: 'NATION'
      }
    }
  })
}
